export const referralCardStyles = {
  card: 'border-0 bg-plum-100 p-0 px-4 py-6 shadow-none [&_[data-slot=card-content]]:w-full [&_[data-slot=card-content]]:min-w-0 am-3xl:px-10 am-3xl:pt-6 am-3xl:pb-8',
  content: 'flex w-full flex-col items-center gap-4 text-center am-3xl:gap-6',
  heroIcon: 'size-12 shrink-0 text-teal-600 am-3xl:size-14',
  intro: 'flex w-full min-w-0 flex-col items-center gap-2 am-3xl:gap-4',
  title: 'w-full text-base font-medium leading-5 text-teal-600 am-3xl:text-2xl am-3xl:leading-7',
  bodyText: 'text-sm leading-5 text-denim-500 am-3xl:leading-5',
  actions: 'flex w-full flex-col gap-4 am-3xl:gap-8',
  linkRow:
    'flex h-10 w-full shrink-0 items-center gap-2 rounded-lg border border-teal-500 bg-gray-100 px-4 am-3xl:mx-auto am-3xl:w-[609px] am-3xl:pr-0',
  linkInput:
    'h-full min-w-0 flex-1 truncate bg-transparent text-sm leading-5 text-denim-800 outline-none',
  shareRow: 'flex flex-col gap-4 am-3xl:flex-row am-3xl:flex-wrap am-3xl:justify-center',
  copyButton:
    'inline-flex items-center justify-center gap-2 rounded-2xl border-transparent bg-denim-500 py-1 pr-5 pl-4 text-white shadow-none hover:bg-denim-400 hover:text-white',
  copyButtonIcon: 'size-5 shrink-0 text-white',
  shareButton:
    'inline-flex h-8 w-full items-center justify-center gap-2 self-stretch rounded-2xl border border-gray-300 bg-white py-1 pr-4 pl-3 text-denim-500 shadow-box-xs hover:border-teal-300 hover:bg-teal-100 am-3xl:w-auto am-3xl:self-auto',
  whatsAppShareButton: '[&>svg]:[stroke-width:1px]',
  shareButtonIcon: 'size-5 shrink-0',
  whatsAppIcon: 'size-5 shrink-0 text-denim-500 [stroke-width:1px]',
} as const;
